exports.f = require('./_wks');


//////////////////
// WEBPACK FOOTER
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/~/core-js/modules/_wks-ext.js
// module id = ../../../../core-js/modules/_wks-ext.js
// module chunks = 0